import styled from 'styled-components';
import { NavMarker } from 'react-rhumb';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import ApiError from '../../../components/Errors/ApiError';
import { OLAF } from 'HubStyleTokens/colors';
import { device } from '../../../constants/StyledComponentConstants';
import DeprecatedError from '../../../components/Errors/DeprecatedError';
import { EmbeddedVideo } from '../../video';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OVERVIEW_MAX_CONTENT_WIDTH = 1180;
const OverviewContentContainer = styled.div.withConfig({
  displayName: "OverviewContent__OverviewContentContainer",
  componentId: "sc-1bifsdv-0"
})(["position:relative;min-height:100%;max-width:100%;display:flex;flex-direction:column;align-self:", ";"], props => props.$isLoading ? 'center' : 'normal');
const HeaderIconWrapper = styled.div.withConfig({
  displayName: "OverviewContent__HeaderIconWrapper",
  componentId: "sc-1bifsdv-1"
})(["position:absolute;right:26px;top:24px;@media screen and ", "{right:68px;}"], device.mobile);
const Loader = styled(UILoadingSpinner).withConfig({
  displayName: "OverviewContent__Loader",
  componentId: "sc-1bifsdv-2"
})(["width:", "px;max-width:100%;flex:1;max-height:660px;"], OVERVIEW_MAX_CONTENT_WIDTH);
const OverviewModalContent = styled.div.withConfig({
  displayName: "OverviewContent__OverviewModalContent",
  componentId: "sc-1bifsdv-3"
})(["width:", "px;max-width:100%;position:relative;margin:0 auto;overflow-x:", ";"], OVERVIEW_MAX_CONTENT_WIDTH, props => props.$allowFullWidthChildren ? 'visible' : 'hidden');
const ErrorMessage = styled.div.withConfig({
  displayName: "OverviewContent__ErrorMessage",
  componentId: "sc-1bifsdv-4"
})(["width:", "px;max-width:100%;color:", ";.missing-content-error a{display:none;}"], OVERVIEW_MAX_CONTENT_WIDTH, OLAF);
export const OverviewContent = ({
  deprecated,
  deprecationCta,
  loading,
  error,
  fallbackThumbnailUrl,
  children,
  headerIcons,
  allowFullWidthChildren = false,
  lessonId,
  trackId,
  shortId,
  assetLanguage,
  onVideoProgress,
  autoplay = true
}) => {
  return /*#__PURE__*/_jsx(OverviewContentContainer, {
    $isLoading: loading,
    children: loading ? /*#__PURE__*/_jsx(Loader, {
      grow: true,
      size: 'medium'
    }) : deprecated ? /*#__PURE__*/_jsx(ErrorMessage, {
      children: /*#__PURE__*/_jsx(DeprecatedError, {
        deprecationCta: deprecationCta
      })
    }) : error ? /*#__PURE__*/_jsx(ErrorMessage, {
      children: /*#__PURE__*/_jsx(ApiError, {
        error: error.networkError,
        marker404: "OVERVIEW_MODAL_API_404",
        markerDefault: "OVERVIEW_MODAL_API_ERROR"
      })
    }) : /*#__PURE__*/_jsx(NavMarker, {
      name: "OVERVIEW_MODAL_LOADED",
      children: /*#__PURE__*/_jsxs(OverviewModalContent, {
        $allowFullWidthChildren: allowFullWidthChildren,
        "data-test-id": "overview-modal-content",
        children: [/*#__PURE__*/_jsx(EmbeddedVideo, {
          autoPlay: autoplay,
          captionsOnByDefault: true,
          fallbackThumbnailUrl: fallbackThumbnailUrl,
          language: assetLanguage,
          lessonId: lessonId,
          mutedByDefault: true,
          onPlay: onVideoProgress,
          shortId: shortId,
          trackId: trackId
        }), /*#__PURE__*/_jsx(HeaderIconWrapper, {
          children: headerIcons
        }), children]
      })
    })
  });
};
export default OverviewContent;